module.exports = __webpack_public_path__ + "static/media/phone.7a6a9e4e.svg";